import React from "react";
import { Link } from "react-router-dom";

export default function Logo(props) {
  return (
    <Link to="/">
      <img
        src={process.env.PUBLIC_URL + "/assets/media/logo.png"}
        alt="Logo"
        {...props}
      />
    </Link>
  );
}
